import z from 'zod';

import { EscrowSettingId } from '../BrandedIds';
import { BaseLoanIdSideEffect } from './BaseLoanIdSideEffect';

export const GenerateMortgageInsuranceCancellationNoticeSideEffectContext = BaseLoanIdSideEffect.extend({
  escrowSettingId: EscrowSettingId,
});

export const GenerateMortgageInsuranceCancellationNoticeSideEffect =
  GenerateMortgageInsuranceCancellationNoticeSideEffectContext.extend({
    type: z.literal('generateMortgageInsuranceCancellationNotice'),
  });
export type GenerateMortgageInsuranceCancellationNoticeSideEffect = z.infer<
  typeof GenerateMortgageInsuranceCancellationNoticeSideEffect
>;
